const Loading = () => {
    return (
        <div className = "spinner"/>
    )
}

export default Loading